export type ImageFormat = 'png' | 'jpeg' | 'webp' | 'gif' | 'bmp' | 'ico'

export interface ImageFormatMeta {
  id: ImageFormat
  label: string
  mimeType: string
  fileExt: string
  supportsQuality: boolean
}

export const IMAGE_FORMATS: ImageFormatMeta[] = [
  {id: 'png', label: 'PNG', mimeType: 'image/png', fileExt: 'png', supportsQuality: false},
  {id: 'jpeg', label: 'JPEG', mimeType: 'image/jpeg', fileExt: 'jpg', supportsQuality: true},
  {id: 'webp', label: 'WebP', mimeType: 'image/webp', fileExt: 'webp', supportsQuality: true},
  {id: 'gif', label: 'GIF', mimeType: 'image/gif', fileExt: 'gif', supportsQuality: false},
  {id: 'bmp', label: 'BMP', mimeType: 'image/bmp', fileExt: 'bmp', supportsQuality: false},
  {id: 'ico', label: 'ICO', mimeType: 'image/x-icon', fileExt: 'ico', supportsQuality: false},
]

/** Sizes offered for multi-resolution ICO export — a single .ico can embed several. */
export const ICO_SIZES = [16, 32, 48, 64, 128, 256] as const

export const DEFAULT_ICO_SIZE = 256

export const CONVERTER_INPUT_ACCEPT =
  'image/png,image/jpeg,image/webp,image/gif,image/bmp,image/x-icon,image/vnd.microsoft.icon'

export const DEFAULT_JPEG_QUALITY = 0.92
